import image_1 from "../images/afro-solar/mega-projects/bg.webp";

const MegaProjects = () => {
  return (
    <div className="container-fluid pt-7" id="mega-projects">
      <div className="me-13 ms-13">
        <div className="row h-100">
          <div className="col-12 col-md-12 col-lg-6 bg-white p-4">
            <h2 className="fs-56 lh-64 gilroy-bold pb-5 text-center text-lg-start">
              <span className="text-orange-ryb">Mega</span> Projects​
            </h2>
            <p className="fs-16 text-align-justify lh-30">
              AFRO Solar can design a fully integrated and customized solar
              power plant project for private and public corporations. We have
              developed and improved on our operational expertise with each
              successive project combined with our quality and safety
              principles, this systematic and integrated approach, enables AFRO
              Solar to execute utility scale solar power projects in Middle-East
              & Africa as per planned schedule. ​ ​ AFRO Solar through its
              consortium of partners, possesses extensive experience and
              expertise in setting up utility-scale land based solar power
              plants for government bodies, power utilities, large corporates
              and industrial establishments. In-house design and engineering
              team, efficient construction teams and deep industry and
              technology know-how are our forte in the utility scale solar
              project segment. ​ ​ Our customers also enjoy the benefits of the
              advisory services that help them understand and gain clarity on
              aspects of financing, policies, land, fiscal benefits, and
              regulatory approvals to successfully install utility scale solar
              projects.​
            </p>
          </div>

          <div
            className="col-12 col-md-12 col-lg-6 d-flex align-items-end"
            style={{
              backgroundImage: `url(${image_1})`,
              backgroundSize: "cover",
            }}
          >
            <div>
              <div className="m-4 bg-white p-4">
                <div className="row">
                  <div className="col-12 col-md-6 d-flex">
                    <img src="" alt="" />
                    <div>
                      <h3 className="fs-28 gilroy-bold text-orange-ryb">92%</h3>
                      <p className="fs-14">
                        By 2050, 92 per cent of power would come from renewable
                        technologies.​
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-12 col-md-6 
              d-flex"
                  >
                    <img src="" alt="" />
                    <div>
                      <h3 className="fs-28 gilroy-bold">100+</h3>
                      <p className="fs-14">
                        Countries with renewable energy targets. ​
                      </p>
                    </div>
                  </div>
                </div>
                <p className="fs-16 lh-30 text-align-justify">
                  We have the prowess to manage solar energy projects of any
                  scale and the much-needed know-how to work within the confines
                  of regulatory policies and vast geographical parameters. our
                  expert design team customizes the solar plants to suit local
                  site conditions to ensure long-life. ​
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaProjects;
